import { useEffect } from 'react'
import { useUsers } from '../../../queries/users'

export const useDownloadUsers = () => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useUsers({ perPage: 200 })
  const total = data?.pages[0]?.meta.total ?? 0
  const users = data?.pages.flatMap((page) => page.data) ?? []
  const userCount = users.length
  const isDone = userCount >= total
  const label = isDone ? 'Download user dump CSV' : `Generating CSV (${userCount} / ${total})`

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) fetchNextPage()
  }, [hasNextPage, isFetchingNextPage])

  const handleClick = () => {
    console.log('users', users.length)
    const csv = users
      .map((user) => `${user.walletAddress},${user.displayName},${user.email}`)
      .join('\n')
    const blob = new Blob(['wallet_address,display_name,email\n' + csv], {
      type: 'text/csv;charset=utf-8;'
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', 'my_data.csv')
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(url)
  }
  return { handleClick, label, isDone }
}
